import TableDynamic from './tableDynamic';
import TableStatic from './tableStatic';

const Index = (props) => {
  return <>{props.type === 'dynamic' ? <TableDynamic height={props.height} redirect={props.redirect} /> : <TableStatic />}</>;
};

export default Index;
